import { render } from "./PrivacyPolicyAndTermsView.vue?vue&type=template&id=4a0079da"
import script from "./PrivacyPolicyAndTermsView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyAndTermsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__